import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Document } from '../classes/document';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class DocumentService {
    API_DOCUMENT_URL = config.serverAddress + ':' + config.serverPort + '/document/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get(this.API_DOCUMENT_URL + 'all');
    }
    getByID(id: string) {
        return this.http.get(this.API_DOCUMENT_URL + id);
    }
    getByIDInspection(idInspection: string | null) {
        return this.http.get(this.API_DOCUMENT_URL + 'inspection/' + idInspection);
    }
    upload(formData: FormData) {
        return this.http.post(this.API_DOCUMENT_URL + 'upload', formData);
    }
    download(idInspection: string, filePath: string) {
        return this.http.post(this.API_DOCUMENT_URL + 'download', {idInspection: idInspection, filePath: filePath}, { responseType: 'blob'});
    }
    create(document: Document) {
        return this.http.post(this.API_DOCUMENT_URL + 'create', document);
    }
    update(document: Document) {
        return this.http.put(this.API_DOCUMENT_URL + 'update', document);
    }
    delete(id: number) {
        return this.http.delete(this.API_DOCUMENT_URL + 'delete/' + id);
    }
}